import { cn } from '@/utils';

type Props = {
  className?: string;
  mode?: 'logo' | 'icon' | 'letters';
  text?: 'dark' | 'light';
  iconClass?: string;
};

export const Logo: React.FC<Props> = ({
  className,
  mode = 'logo',
  text = 'dark',
  iconClass = 'fill-red-500',
}) => {
  const viewBoxes = {
    logo: '0 0 353 100',
    icon: '0 0 100 100',
    letters: '130 0 223 100',
  };

  const textPropClasses =
    text === 'dark'
      ? 'text-dark dark:text-ivory'
      : 'text-ivory dark:text-ivory';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox={viewBoxes[mode]}
      //viewBox="0 0 353 100"
      className={cn(className)}>
      <path
        fillRule="evenodd"
        d="M132.14 47.62V70h9.12V55h11.1c5.46 0 7.02 1.68 7.62 8.28l.123 1.205c.361 3.534.397 3.884.777 5.515h10.14c-1.02-2.1-1.14-2.52-1.56-8.1-.42-7.68-1.86-9.9-6.9-10.98 2.34-.84 3.42-1.38 4.56-2.34 2.28-1.92 3.48-4.56 3.48-7.86 0-4.2-1.92-7.68-5.1-9.36-2.04-1.02-4.56-1.38-9.84-1.38h-23.52v7.62h21c2.58 0 3.42.06 4.38.42 1.92.6 3 2.28 3 4.44 0 2.16-1.08 3.84-2.94 4.62-1.02.42-1.8.54-4.44.54h-21Z"
        clipRule="evenodd"
        fill="currentColor"
        className={textPropClasses}
        //className={text === 'dark' ? 'text-dark dark:text-white' : 'text-white'}
      />
      <path
        fillRule="evenodd"
        d="M132.14 47.62V70h9.12V55h11.1c5.46 0 7.02 1.68 7.62 8.28l.123 1.205c.361 3.534.397 3.884.777 5.515h10.14c-1.02-2.1-1.14-2.52-1.56-8.1-.42-7.68-1.86-9.9-6.9-10.98 2.34-.84 3.42-1.38 4.56-2.34 2.28-1.92 3.48-4.56 3.48-7.86 0-4.2-1.92-7.68-5.1-9.36-2.04-1.02-4.56-1.38-9.84-1.38h-23.52v7.62h21c2.58 0 3.42.06 4.38.42 1.92.6 3 2.28 3 4.44 0 2.16-1.08 3.84-2.94 4.62-1.02.42-1.8.54-4.44.54h-21Z"
        clipRule="evenodd"
        fill="currentColor"
        className={textPropClasses}
        // className={`${text == 'dark' ? 'text-dark dark:text-white' : 'text-white dark:text-white'}`}
      />
      <path
        d="M194.14 29.98 174.94 70h10.02l4.08-9 3.3-7.08 6-13.32 6.18 13.32 3.24 7.08 4.26 9h10.86l-19.62-40.02h-9.12ZM235.18 70V54.16l-18.66-24.18h11.82l11.58 16.08 11.34-16.08h11.34l-18.3 24.18V70h-9.12ZM268.14 70V29.98h9.12v32.4h22.56V70h-31.68ZM327.82 28.84c14.58 0 24.36 8.64 24.36 21.42 0 12.36-9.9 20.88-24.3 20.88-6.96 0-12.96-1.92-17.46-5.64-4.68-3.9-6.96-9-6.96-15.54 0-12.48 9.9-21.12 24.36-21.12Zm0 7.38c-8.34 0-14.22 5.64-14.22 13.68 0 8.22 5.82 13.92 14.22 13.92 8.22 0 14.16-5.76 14.16-13.8 0-8.1-5.82-13.8-14.16-13.8Z"
        fill="currentColor"
        className={textPropClasses}
        //className={`${text == 'dark' ? 'text-dark dark:text-white' : 'text-white dark:text-white'}`}
      />
      <path
        fillRule="evenodd"
        d="M86.11 90.332c-2.661 2.658-5.87 4.456-9.592 5.926-1.83.722-3.8 1.28-5.89 1.809C64.5 99.617 57.326 100 49.75 100c-11.24-.001-21.613-1.136-29.333-5.02-.132-.067-.265-.131-.398-.195-.301-.146-.601-.29-.885-.46-.197-.12-.386-.257-.576-.395a8.955 8.955 0 0 0-.56-.385c-1.596-.981-3.106-2.093-4.375-3.401-2.598-2.677-4.89-5.503-6.94-8.763-2.028-3.226-3.522-6.912-4.665-11.165C-.2 61.958-.287 50.581.328 40.371c.304-5.043 1.29-9.446 2.595-13.41 1.296-3.936 3.244-7.331 5.394-10.386 2.197-3.12 4.598-5.93 7.406-8.263 2.796-2.323 6.137-4.12 10.001-5.458C30.522 1.193 35.934.364 42.082.109 43.74.041 45.386.036 47.042.03c.773-.002 1.549-.005 2.33-.014 7.195-.084 14.495.118 20.439 1.59 6.221 1.542 11.34 3.968 15.453 7.735.806.737 1.601 1.55 2.333 2.37 4.372 4.91 8.288 10.632 10.292 18.088a52.353 52.353 0 0 1 1.516 8.109c.604 5.69.725 12.366.467 18.648-.386 9.4-2.186 16.971-5.598 23.11a46.046 46.046 0 0 1-8.163 10.666ZM58 57.75h12.5l7.978 15.326c.693 1.332-.273 2.924-1.774 2.924h-6.17a5 5 0 0 1-4.435-2.691L58 57.75Zm-25.5-.125H20v15.25a3 3 0 0 0 3 3h6.5a3 3 0 0 0 3-3v-15.25Zm-12.5-3.5 47.5-.495C74.424 53.558 80 47.925 80 41l-60 .625v12.5ZM27.5 25a7.5 7.5 0 0 0-7.5 7.5v5h60C80 30.596 74.403 25 67.5 25h-40Z"
        clipRule="evenodd"
        fill="currentColor"
        className={iconClass}
      />
    </svg>
  );
};
